import API from '../../api';

const types = {
  GET_ISSUES_SUCCESS: 'GET_ISSUES_SUCCESS',
  GET_ISSUES_ERROR: 'GET_ISSUES_ERROR',
}

const state = {
  all: []
}

const getters = {
  byId: state => id => {
    return state.all.find(item => item.id == id);
  },
}

const actions = {
  get({ commit }, params) {
    return API.issues.get(params).then(response => {
      commit(types.GET_ISSUES_SUCCESS, response.data.result);
      return response;
    }).catch(error => {
      commit(types.GET_ISSUES_ERROR);
    });
  },
}

const mutations = {
  [types.GET_ISSUES_SUCCESS](state, issues) {
    state.all = issues;
  },

  [types.GET_ISSUES_ERROR](state) {
    state.all = [];
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
